import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-427fe142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "text-xs text-gray-500 italic mt-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs italic mt-2 w-full p-2 bg-amber-300 rounded max-w-[30rem]"
}
const _hoisted_4 = { class: "flex justify-end gap-4 w-full" }

import { IconBase } from "@/ui-elements"
import { useI18n } from "vue-i18n"
import ButtonBase from "@/ui-elements/button-base/ButtonBase.vue"
import NotificationComponent from "@/ui-elements/NotificationComponent.vue"
import SelectComponent from "@/ui-elements/input/select/SelectComponent.vue"
import PopUpModal from "@/ui-elements/layout/modals/PopUpModal.vue"
import { updatesStore, riceCookerPostponeUpdateOptions } from "@/store/Updates"
import { useRoute } from "vue-router"
import { ref } from "vue"
import { gtmSendCustomEvent } from "@/utils/gtmSendEvent"

export default /*#__PURE__*/_defineComponent({
  __name: 'RiceCookerUpdateModal',
  setup(__props) {

const { t: translate } = useI18n()
const route = useRoute()
const manualDownloadNotice = ref(false)
function closeRiceCookerUpdateModal() {
    if (!updatesStore().riceCookerIsUpdating) {
        gtmSendCustomEvent("RiceCookerUpdateModal", "closeUpdateModal")
        updatesStore().postponeRiceCookerUpdate(5, false)
    }
}
function downloadUpdateManually() {
    gtmSendCustomEvent("RiceCookerUpdateModal", "downloadUpdateManually")
    manualDownloadNotice.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopUpModal, {
    show: 
            _unref(updatesStore)().riceCookerUpdateModalIsVisible &&
            !_unref(route).fullPath.includes('customer-screen')
        ,
    class: "update-modal"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_unref(translate)("software_update")), 1),
        _createVNode(_unref(IconBase), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeRiceCookerUpdateModal())),
          icon: "delete",
          class: _normalizeClass(["icon-close", [
                        _unref(updatesStore)().riceCookerIsUpdating ? 'disabled' : '',
                    ]])
        }, null, 8, ["class"])
      ])
    ]),
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SelectComponent, {
          disabled: _unref(updatesStore)().riceCookerIsUpdating,
          value: _unref(updatesStore)().riceCookerPostponeUpdateValue,
          options: _unref(riceCookerPostponeUpdateOptions),
          "can-search": false,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (
                        _unref(updatesStore)().postponeRiceCookerUpdate($event)
                    )),
          "drop-up": true,
          class: "w-full"
        }, null, 8, ["disabled", "value", "options"]),
        _createVNode(ButtonBase, {
          loading: _unref(updatesStore)().riceCookerIsUpdating,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(updatesStore)().applyRiceCookerUpdate())),
          class: "w-full"
        }, {
          default: _withCtx(() => [
            (!_unref(updatesStore)().riceCookerIsUpdating)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(translate)("install_now")) + " (" + _toDisplayString(Math.floor(
                                _unref(updatesStore)().riceCookerAutomaticUpdateTimer /
                                    60
                            )) + ": " + _toDisplayString(_unref(updatesStore)().riceCookerAutomaticUpdateTimer -
                            Math.floor(
                                _unref(updatesStore)().riceCookerAutomaticUpdateTimer /
                                    60
                            ) *
                                60) + ") ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(translate)("installing")), 1)
                ], 64))
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["content", [
                !_unref(updatesStore)().riceCookerUpdateErrorIsVisible
                    ? 'content-white-spaced'
                    : '',
            ]])
      }, [
        _createElementVNode("h3", null, _toDisplayString(_unref(translate)("updates_available")), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(translate)("update_available_to_install")), 1),
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(_toDisplayString(_unref(translate)("update_fails_or_long")) + " ", 1),
          _createElementVNode("a", {
            href: "https://downloads.foodticket.nl/OrderBuddy.exe",
            class: "text-xs",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadUpdateManually())),
            download: ""
          }, _toDisplayString(_unref(translate)("update_download_manual")), 1),
          _createTextVNode(". ")
        ]),
        (manualDownloadNotice.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(translate)("update_download_manual_notice")), 1))
          : _createCommentVNode("", true)
      ], 2),
      (_unref(updatesStore)().riceCookerUpdateErrorIsVisible)
        ? (_openBlock(), _createBlock(NotificationComponent, {
            key: 0,
            class: "notification",
            "notification-type": "error"
          }, {
            notificationLabel: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)("update_failed")), 1)
            ]),
            notificationMessage: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)("please_try_again")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})